<template>
  <div v-bind:class="{ 'op--modal-container': true, hide: !show }" @click="close">
    <div class="op--modal">
      <div class="op--modal-content">
        <div class="guest-input small-margin-v-s" @click.stop>
          <div class="title">{{ $t('rsvpEdit.whoBooking') }}</div>
          <form @submit.prevent="addGuest">
            <input type="text" class="field-text" :placeholder="$t('rsvpEdit.firstName')" v-model="firstName" />
            <input type="text" class="field-text" :placeholder="$t('rsvpEdit.lastName')" v-model="lastName" />
            <input type="text" class="field-text" :placeholder="$t('rsvpEdit.phoneNumber')" v-model="phone" />
            <div v-bind:class="{ 'error-message': true, hide: !error.show }">{{ error.message }}</div>
            <button class="op-btn btn-block btn-success btn-lg margin-t-s">{{ $t('rsvpEdit.save') }}</button>
            <a href="javascript:;" class="remove-btn" @click="clearGuest">{{ $t('rsvpEdit.bookForMyself') }}</a>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'guest-information',
  data () {
    return {
      firstName: '',
      lastName: '',
      phone: '',
      error: {
        show: false,
        message: this.$t('rsvpEdit.nameRequired')
      }
    }
  },
  computed: {
    show () { return this.$store.state.rsvpEdit.guestInformation.show }
  },
  methods: {
    close () { this.$store.commit('rsvpEdit/hideGuestInformation') },
    addGuest () {
      let self = this
      self.error.show = false
      if (self.firstName === '' || self.lastName === '') {
        self.error.show = true
        return
      }
      self.$store.commit('rsvpEdit/setEditedGuest', {
        firstName: self.firstName,
        lastName: self.lastName,
        phone: self.phone
      })
      self.close()
    },
    clearGuest () {
      this.$store.commit('rsvpEdit/setEditedGuest', {
        firstName: null,
        lastName: null,
        phone: null
      })
      this.close()
    }
  },
  watch: {
    show (value) {
      if (!value) {
        return
      }

      let self = this
      self.error.show = false
      self.firstName = ''
      self.lastName = ''
      self.phone = ''

      let editedGuest = self.$store.state.rsvpEdit.editedRsvp.guest
      if (editedGuest.firstName !== null) {
        self.firstName = editedGuest.firstName
      }
      if (editedGuest.lastName !== null) {
        self.lastName = editedGuest.lastName
      }
      if (editedGuest.phone !== null) {
        self.phone = editedGuest.phone
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.guest-input {
  background-color: #fff;
  max-width: 300px;
  margin: 10px auto;
  padding: 20px;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);

  & .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 15px;
  }
}

.remove-btn {
  text-align: center;
  margin-top: 15px;
  display: block;
}

.error-message {
  text-align: center;
  font-size: 14px;
  line-height: 14px;
  color: #fff;
  padding: 5px;
  border-radius: 3px;
  background-color: #EB5837;
  display: block;
  &.hide { display: none; }
}
</style>


// WEBPACK FOOTER //
// GuestInformation.vue?2f241f08